import { makeStyles } from '@material-ui/core'

export const useDateFormStyles = makeStyles(() => ({
  form: {
    position: 'relative',
    zIndex: 0,
  },
  card: {
    '&&': {
      marginBottom: 'var(--vel-fixed-spacing-05)',
      zIndex: 1,
    },
    '&&:focus-within': {
      zIndex: 3,
    },
  },
  preferredCard: {
    '&&': {
      zIndex: 2,
    },
  },
  heading: {
    '&&': {
      marginBottom: 'var(--vel-fixed-spacing-04)',
    },
  },
  headingWithText: {
    '&&': {
      marginBottom: 'var(--vel-fixed-spacing-02)',
    },
  },
  explanation: {
    '&&': {
      marginBottom: 'var(--vel-fixed-spacing-05)',
    },
  },
  rows: {
    '& > div > div': {
      position: 'relative',
    },
    '& > div > div:not(:first-child)': {
      marginBottom: 'var(--vel-fixed-spacing-07) !important',
    },
    '& > div:last-child > div:not(:first-child)': {
      marginBottom: 'var(--vel-fixed-spacing-02) !important',
    },
    '& > div > *:nth-child(3)': {
      maxWidth: 'none',
      flexShrink: 0,
    },
    '& [id$="_helper-text"]': {
      position: 'absolute',
      top: '100%',
      left: 0,
      whiteSpace: 'nowrap',
    },
    '& > div > *:nth-child(3) [id$="_helper-text"]': {
      left: 'auto',
      right: 0,
    },
  },
  rowsWithHint: {
    '& > div + div': {
      margin: '0 !important',
    },
  },
}))
